import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, CircleHelp } from 'lucide-react';

export function GeoFaq({ items, title, className = '' }) {
  const { t } = useTranslation();
  const heading = title || t('search.faqTitle', 'Sık sorulan sorular');
  if (!items?.length) return null;
  return (
    <section className={className} data-testid="geo-faq">
      <details className="group rounded-2xl border border-neutral-200 bg-white">
        <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-4 py-3 text-sm font-semibold text-neutral-800 [&::-webkit-details-marker]:hidden">
          <span className="flex items-center gap-2">
            <CircleHelp className="h-4 w-4 text-neutral-400" aria-hidden />
            {heading}
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 text-neutral-400 transition-transform group-open:rotate-180" aria-hidden />
        </summary>
        <dl className="border-t border-neutral-100 px-4 py-2">
          {items.map((item) => (
            <div key={item.question} className="border-b border-neutral-100 py-3 last:border-b-0">
              <dt className="text-sm font-medium text-neutral-900">{item.question}</dt>
              <dd className="m-0 mt-1 text-sm leading-relaxed text-neutral-500">{item.answer}</dd>
            </div>
          ))}
        </dl>
      </details>
    </section>
  );
}
